<template>
    <div id="app" class="root-app" ref="app">
        <van-skeleton v-for="item in [1, 2, 3, 4, 5, 6, 7]" :key="item" title avatar :row="3" :loading="loading" />
        <van-overlay :show="globalOnAutoRenewalToken" @click.stop>
            <div class="wrapper" @click.stop>您的令牌已过期，已重新获取，请在稍后重试。</div>
        </van-overlay>
        <van-sticky ref="appDownload" :offset-top="0" v-if="globalShowDownload && showDownload && selfEqTop">
            <div class="c-download" @click="downloadKb">
                <img src="//static.kaiba315.com.cn/kaiba-logo.png" class="c-download-logo" />
                <span class="c-download-h">开吧</span>
                <span class="c-download-p">开启城市幸福生活吧</span>
                <div style="flex: 1"></div>
                <input type="button" class="c-download-btn" value="下载" />
                <img src="//static.kaiba315.com.cn/kbbtn-close-grey.png" class="c-download-close"
                     @click.stop="closeDownload()" />
            </div>
        </van-sticky>
        <van-overlay class="open-wechat-overlay" :show="globalShowOpenInBrowser" @click="onTapBrowserOverlay">
            <van-image width="70%" style="margin: 12px 24px" src="https://static.kaiba315.com.cn/openmasktip.png" />
        </van-overlay>
        <van-empty
            v-if="globalKbRequestError.visible"
            :image="globalKbRequestError.image"
            :description="globalKbRequestError.description"
        >
            <van-button v-if="globalKbRequestError.retry" round type="danger" class="bottom-button" @click.stop="reload"
            >点击重试
            </van-button
            >
        </van-empty>
        <div class="root-app-routerview">
            <router-view v-if="!loading && !globalKbRequestError.visible" />
        </div>
    </div>
</template>
<script>
import { localUserInfo } from '@/utils/user'
import { defineShareModelState, definePermissionUsage } from '@/utils/kb-bridge'
import { isKbApp, isWechat, decorateOnlyInKbApp } from './hooks/use-env'
import { wechatSignLink } from '@/utils/wx'

export default {
    name: 'App',
    data() {
        return {
            loading: true,
            showDownload: false,
            selfEqTop: window.self === window.top,
        }
    },
    computed: {
        globalShowDownload() {
            return this.$store.getters['global/getShowDownload']
        },
        globalOnAutoRenewalToken() {
            return this.$store.getters['global/getOnAutoRenewalToken']
        },
        globalKbRequestError() {
            return this.$store.getters['global/getKbRequestError']
        },
        globalShowOpenInBrowser() {
            return this.$store.state.global.showOpenInBrowser
        },
    },
    created() {
        wechatSignLink.init()
        let _self = this
        this.transformUrl()
        setTimeout(() => {
            _self.loading = false
        }, 500)
        _self.showDownload = !isKbApp
        if (isKbApp) {
            localUserInfo(_self)
        }

        definePermissionUsage({
            microphone: { description: '用于发帖上传音频' },
            location: { description: '获取你选择的位置信息，用于线下导航服务' },
            camera: { description: '收集你选中的照片或视频信息 ，用于 发表评论、分享视频' },
        })
        defineShareModelState({ showMenu: true, panelStyle: 0 })
        sensors.registerPage({
            platform_type: isKbApp ? 'APP' : isWechat ? 'Wechat' : 'H5',
        })
    },
    watch: {
        $route() {
            if (window._czc) {
                //监听路由变化
                let location = window.location
                let contentUrl = location.pathname + location.hash
                let refererUrl = '/'
                window._czc.push(['_trackPageview', contentUrl, refererUrl])
            }
        },
    },
    methods: {
        transformUrl() {
            let pathName = window.location.pathname
            if (pathName.indexOf('/app_page/Red/redList.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'red/list' + query,
                })
            } else if (pathName.indexOf('/app_page/Red/prize.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'red/prize' + query,
                })
            } else if (pathName.indexOf('/app_page/Red/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'red/index' + query,
                })
            } else if (
                pathName.indexOf('/app_page/HotTopic/index.html') != -1 ||
                pathName.indexOf('/app_page/HotTopic/share.html') != -1
            ) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'hottopic/index' + query,
                })
            } else if (pathName.indexOf('/app_page/ContentAlbum/lists.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'contentAlbum/list' + query,
                })
            } else if (pathName.indexOf('/app_page/Boutiquepurchase/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'rushBuy/index' + query,
                })
            } else if (pathName.indexOf('/app_page/Enroll/list.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'enroll/list' + query,
                })
            } else if (pathName.indexOf('/app_page/News/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'news/index' + query,
                })
            } else if (pathName.indexOf('/app_page/News/indexForSure.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'news/indexForSure' + query,
                })
            } else if (pathName.indexOf('/app_page/News/advert.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'news/advert' + query,
                })
            } else if (pathName.indexOf('/app_page/News/advertForSure.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'news/advertForSure' + query,
                })
            } else if (pathName.indexOf('/app_page/PlayBack/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'playback/index' + query,
                })
            } else if (pathName.indexOf('/app_page/PlayBack/album.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'playback/album' + query,
                })
            } else if (pathName.indexOf('/app_page/PlayBack/share.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'playback/audio' + query,
                })
            } else if (pathName.indexOf('/app_page/newPrivacy/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'privacy/index' + query,
                })
            } else if (pathName.indexOf('/app_page/Privacy/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'privacy/index' + query,
                })
            } else if (pathName.indexOf('/app_page/Privacy/policy.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'privacy/policy' + query,
                })
            } else if (pathName.indexOf('/app_page/newPrivacy/policy.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'privacy/policy' + query,
                })
            } else if (pathName.indexOf('/app_page/ProgramAd/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'programAd/index' + query,
                })
            } else if (pathName.indexOf('/app_page/ProgramPlaying/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'programPlaying/index' + query,
                })
            } else if (pathName.indexOf('/app_page/logout/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'logout/index' + query,
                })
            } else if (pathName.indexOf('/app_page/logout/protocol.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'logout/protocol' + query,
                })
            } else if (pathName.indexOf('/app_page/logout/other.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'logout/other' + query,
                })
            } else if (pathName.indexOf('/app_page/logout/account.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'logout/account' + query,
                })
            } else if (pathName.indexOf('/app_page/logout/phone.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'logout/phone' + query,
                })
            } else if (pathName.indexOf('/app_page/logout/verify.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'logout/verify' + query,
                })
            } else if (pathName.indexOf('/app_page/SurplusUpgrade/index.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'surplusUpgrade/index' + query,
                })
            } else if (pathName.indexOf('/app_page/Util/KbBridgeAutomate.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'verification/verifyJs' + query,
                })
            } else if (pathName.indexOf('/app_page/Util/KbActionDemo.html') != -1) {
                let query = this.getUrlParameters()
                this.$router.replace({
                    path: 'verification/verifyAction' + query,
                })
            }
        },
        closeDownload() {
            this.showDownload = false
        },
        downloadKb: decorateOnlyInKbApp(() => {
        }),
        getUrlParameters() {
            let parameterString = ''
            var url = window.location.search
            if (url.indexOf('?') != -1) {
                parameterString = url
            }
            return parameterString
        },
        reload() {
            this.$store.dispatch('global/updateKbRequestErrorVisible', false)
            window.location.reload()
        },
        onTapBrowserOverlay() {
            this.$store.dispatch('global/updateOpenInBrowser', false)
        },
    },
}
</script>
<style>
:root {
    --color-primary: #ff7600;
    --spacing-xs: 4px;
    --spacing-sm: 8px;
    --spacing-md: 13px;
    --spacing-lg: 16px;
    --spacing-xl: 24px;

    /** 卡片间距 */
    --spacing-card: 10px;

    --font-size-header: 20px;
    --font-size-title: 17px;
    --font-size-subtitle: 15px;
    --font-size-content: 16px;
    --font-size-desc: 13px;
}
</style>
<style lang="scss">
@import './assets/main.css';
@import './assets/flex.scss';
@import './assets/fontLatest/font.css';

.ma-md {
    margin: var(--spacing-md);
}

.ma-auto {
    margin: auto;
}

body {
    color: #313131;
}

.root-app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    &-routerview {
        position: relative;
        flex: 1;
    }
}
</style>
<style scoped>
.c-download {
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
}

.c-download-logo {
    margin: 5px 10px;
    width: 30px;
    height: 30px;
}

.c-download-h {
    font-size: 20px;
    font-weight: 600;
}

.c-download-p {
    font-size: 12px;
    margin: 5px;
}

.c-download-btn {
    border: 1px solid #f70;
    padding: 0 5px;
    -webkit-appearance: none;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: #f70;
    background-color: transparent;
    border-radius: 4px;
}

.c-download-close {
    margin: 10px;
    width: 15px;
    height: 15px;
}
</style>
<style>
.auto-item {
    padding: 5px 10px;
    font-size: 16px;
    white-space: break-spaces;
}

.auto-item-span {
    display: block;
    font-size: 14px;
}

.amap-logo {
    opacity: 0;
}

.amap-copyright {
    opacity: 0;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: white;
}

.open-wechat-overlay {
    z-index: 9999;
    text-align: right;
}

.fade-in {
    animation: 1s cubic-bezier(0.29, 1.04, 0.38, 1) 0s 1 normal both running key-fade-in;
}

.fade-in-up {
    animation: 1s cubic-bezier(0.29, 1.04, 0.38, 1) 0s 1 normal both running key-fade-in-up;
}

@keyframes key-fade-in {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes key-fade-in-up {
    0% {
        opacity: 0;
        transform: translateY(100%);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.extend-valid {
    position: relative;
}

.extend-valid::before {
    content: '';
    --valid-area: calc(-1 * var(--spacing-12));
    position: absolute;
    top: var(--valid-area);
    right: var(--valid-area);
    bottom: var(--valid-area);
    left: var(--valid-area);
}
</style>
